export default __webpack_public_path__ + "static/media/mssg.cc628c75.svg";